import React from "react";
import { PALETTE } from "../../common/ThemeConstants";

export default function Feature({
  icon,
  title,
  description,
  height = 100,
  titleColor = PALETTE.DARK,
  descriptionColor = PALETTE.GRAY,
}) {
  return (
    <div className="text-center" style={{ height: height }}>
      {icon}
      <p
        className="mb-0"
        style={{
          marginTop: "1rem",
          fontSize: "1rem",
          color: titleColor,
        }}
      >
        {title}
      </p>
      <p style={{ fontSize: 14, color: descriptionColor }}>{description}</p>
    </div>
  );
}
